'use strict'

import React,{Component} from 'react';
import {renderToString} from 'react-dom/server';
import FormattedContent from '../components/FormattedContent.jsx';

export class FormattedSlide extends React.Component {
  render() {
    let slideType=this.props.slideType!==undefined ? this.props.slideType : "normal";
    return this.props.content!==undefined && this.props.content!==null &&
          (this.props.content.trim!==undefined && this.props.content.trim().length>0 || this.props.content.trim===undefined) ?
    ( slideType==="title" ? (
      <div style={{textAlign:"center", paddingTop:100}}>
        <h1> {this.props.label} </h1>
        <h3><FormattedContent value={this.props.content}/></h3>
      </div>
    ) : slideType==="preformatted" ? (
      <div>
        <h2> {this.props.label} </h2>
        {this.props.children}
      </div>
    ) : (
      <div>
        <h2> {this.props.label} </h2>
        <FormattedContent value={this.props.content}/>
      </div>
    )
    ) : null;
  }
}

class SlideLink extends React.Component {
  constructor(props) {
    super(props);
    this.state={slideNo:this.props.slideNo};
  }

  render() {
    return (
      <div>
        <a href="#" onClick={this.props.setSlide(this, this.props.slideNo)}>{this.props.slideTitles[this.props.index]}</a>
      </div>
    );
  }
}

export default class Slides extends React.Component {
  constructor(props) {
    super(props);
    this.state={slideNo:0, tableofcontent:false};
  }


  nextSlide(event) {
    event.preventDefault();
    this.setState({slideNo:++this.state.slideNo});
    while (this.slideIsEmpty(this.props.slides[this.state.slideNo]) && this.state.slideNo<this.props.slides.length-1) {
      this.setState({slideNo:++this.state.slideNo});
    }
  }


  previousSlide(event) {
    event.preventDefault();
    this.setState({slideNo:--this.state.slideNo});
    while (this.slideIsEmpty(this.props.slides[this.state.slideNo]) && this.state.slideNo>0) {
      this.setState({slideNo:--this.state.slideNo});
    }
  }

  showToC(event) {
    event.preventDefault();
    this.setState({tableofcontent:true});
  }

  hideToC(event) {
    event.preventDefault();
    this.setState({tableofcontent:false});
  }

  slideIsEmpty(slide) {
    return renderToString(slide).indexOf("</div>")<0 ? true : false;
  }

  render () {

    return (
      <div style={{marginLeft:30, marginTop:30, minWidth:1256, display:"inline-flex", justifyContent:"space-between", fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif"}}>
      <div>{this.state.tableofcontent? (
        <div style={{border:"1px solid #E5E5E5", boxShadow: "0px 8px 16px rgba(0,0,0,0.15)", borderRadius: 4, backgroundColor:"#ffffff", width:155, fontSize:17, fontFamily:"Lato, Arial, Verdana, Geneva, sans-serif", marginTop:15, marginRight:10, paddingTop:5, paddingBottom:16, paddingLeft:5, paddingRight:12}}>
          <a href="#" style={{paddingLeft:5, marginTop: 10, float:"left"}} onClick={this.hideToC.bind(this)}><img src="/icons/chevron_left.png"/></a>
          <br/><br/><br/>
            <ol style={{paddingLeft:25, paddingTop:5, paddingRight:5, paddingBottom: 10, margin:0}}>
              {this.props.slides.map((slide, index)=>
                <div>
                  {!this.slideIsEmpty(slide)? (
                  <a href="#"  style={{paddingTop: 10, textDecoration: "none", fontWeight: index===this.state.slideNo? "bold" : "normal", color:index===this.state.slideNo? "#18586D": "#212121"}} onClick={(event)=>{event.preventDefault(); this.setState({slideNo:index})}}>
                      {this.props.slideTitles[index]!==null && this.props.slideTitles[index]!==undefined ? <li style={{marginTop:5}}>{this.props.slideTitles[index]}</li> : null}
                  </a>) : null
                  }
                </div>
              )}
            </ol>
        </div>
      ) : this.props.slideTitles!==undefined?
            (<a href="#" style={{paddingLeft:5, marginTop: 25, float:"left"}} onClick={this.showToC.bind(this)}><img src="/icons/menu.png"/></a>)
            : null
         }
      </div>

        <div>
          <div style={{paddingTop: 150, minWidth:130}} >
            {this.state.slideNo>0 ? (
              <input className="slideNavigation" style={{marginLeft: 10, float:"left"}} onClick={this.previousSlide.bind(this)} type="button" value="<"/>
            ) : null}
          </div>
        </div>
        <div style={{minWidth:780, width:"100%"}}>
          {this.props.slides[this.state.slideNo]}
        </div>

        <div style={{paddingTop:150,  minWidth:120}} >
          {this.state.slideNo<this.props.slides.length-1 ? (
            <input className="slideNavigation" style={{float:"right"}} onClick={this.nextSlide.bind(this)} type="button" value=">"/>
          ) : null}
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/Slides.jsx